import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { Static } from '../util/static';
@Component({
    selector: 'iw-button-view-flow',
    template: '<button [disabled]="disableBtn" class="btn btn-xs btn-info" (click)="onClick()">Ver anexos</button>',
    styles: [`
          .btn-xs {
              font: normal !important;
          }
      `]
  })
  export class ButtonViewAttachmentsComponent implements ViewCell, OnInit{
    // entrada del valor del boton
    @Input() value: number;
    // entrada de la fila a la cual se le dio click
    @Input() rowData: any;
    // bloquea el boton si no hay registros
    disableBtn = false;
    // Cambiar clase
    cssClass = 'btn-success';
    // contiene el valor de entrada
    renderValue: string;
    // salida del evento del click
    @Output() save: EventEmitter<any> = new EventEmitter();

    ngOnInit(): void {
      if (this.value == -1 || this.value == null){
        this.disableBtn = true;
        this.renderValue = "";
      }else{
        this.renderValue = this.value.toString().toUpperCase();
      }
    }

      /**
   * Emite el evento retornando la data de la fila selecionada al dar click en el boton
   *
   * @memberof ButtonViewAttachmentsComponent
   */
  onClick() {
    this.save.emit(this.rowData);
  }
      
  }


// WEBPACK FOOTER //
// ./src/app/shared/component-table/button-view-attachments.component.ts